import React, { useEffect, useState } from "react";
import { api, V1 } from "@/lib/api";
import { Package, Check, Lock, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import PurchaseButton from "@/components/PurchaseButton";

const ICONS = {
  school_analytics: "📊", school_mock_exams: "🎫", school_gallery: "📸",
  school_messaging: "💬", school_announcements: "📢", school_brochure: "📄",
  school_targeting: "🎯", virtual_tour: "🎬",
};
const READY = {
  school_announcements: true,
  school_analytics: true,
  school_mock_exams: true,
  school_gallery: true,
  school_brochure: true,
  school_messaging: true,
  school_targeting: true,
  virtual_tour: true,
};
const OPEN_URL = {
  school_announcements: "/okul-paneli/duyurular",
  school_analytics: "/okul-paneli/analitik",
  school_mock_exams: "/okul-paneli/deneme-sinavlarim",
  school_gallery: "/okul-paneli/galeri",
  school_brochure: "/okul-paneli/brosur",
  school_messaging: "/okul-paneli/mesajlar",
  school_targeting: "/okul-paneli/hedefleme",
  virtual_tour: "/okul-paneli/galeri",
};

export default function SchoolModules() {
  const [items, setItems] = useState([]);
  const load = () => api.get(`${V1}/school-modules`).then((r) => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6" data-testid="school-modules-page">
      <div>
        <div className="overline text-accent">Modüller</div>
        <h1 className="font-display text-3xl font-bold flex items-center gap-2">
          <Package className="h-7 w-7 text-primary" /> Modül Aboneliklerim
        </h1>
        <p className="text-muted-foreground text-sm mt-1 max-w-2xl">
          Okulunuzun ihtiyacına göre modülleri seçin. Aylık veya yıllık (2 ay bedava)
          alabilirsiniz. Talebiniz süper admin onayı sonrası hesabınıza tanımlanır.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((m) => {
          const ready = READY[m.key];
          return (
            <div key={m.key} className={`p-6 rounded-xl border ${m.owned ? "border-success/40 bg-success/5" : "border-border bg-card"} relative`} data-testid={`sm-card-${m.key}`}>
              {m.owned && (
                <div className="absolute top-3 right-3 flex items-center gap-1 text-xs text-success font-bold">
                  <Check className="h-3.5 w-3.5" /> Aktif
                </div>
              )}
              <div className="text-3xl mb-2">{ICONS[m.key] || "🧩"}</div>
              <div className="font-display font-bold text-lg">{m.label}</div>
              <p className="text-sm text-muted-foreground mt-1 min-h-[40px]">{m.description}</p>
              {!m.owned && (
                <div className="grid grid-cols-2 gap-2 mt-4">
                  <div className="p-2 rounded border border-border text-center">
                    <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Aylık</div>
                    <div className="font-display font-bold">₺{m.price_monthly}</div>
                  </div>
                  <div className="p-2 rounded border border-accent/40 bg-accent/5 text-center">
                    <div className="text-[10px] uppercase tracking-widest text-accent">Yıllık</div>
                    <div className="font-display font-bold">₺{m.price_yearly}</div>
                  </div>
                </div>
              )}
              {m.owned && m.subscription && (
                <div className="mt-4 text-xs text-muted-foreground flex items-center gap-1">
                  <Calendar className="h-3 w-3" />
                  {new Date(m.subscription.expires_at).toLocaleDateString("tr-TR")}&apos;e kadar aktif
                </div>
              )}
              {m.key === "virtual_tour" && (
                <div className="mt-3 text-[11px] text-muted-foreground">Tur, okul galerinizdeki fotoğraflardan otomatik oluşturulur — ekstra yükleme gerekmez.</div>
              )}
              <div className="mt-4 flex gap-2 flex-wrap">
                {!m.owned ? (
                  <>
                    <PurchaseButton kind="module" code={m.key} cycle="monthly" price={m.price_monthly} label={`₺${m.price_monthly}/ay`} size="sm" testId={`sm-buy-monthly-${m.key}`} />
                    <PurchaseButton kind="module" code={m.key} cycle="yearly" price={m.price_yearly} label={`₺${m.price_yearly}/yıl`} size="sm" variant="outline" testId={`sm-buy-yearly-${m.key}`} />
                  </>
                ) : (
                  ready ? (
                    <Button size="sm" variant="outline" asChild className="flex-1" data-testid={`sm-open-${m.key}`}>
                      <a href={OPEN_URL[m.key] || "#"}>Aç</a>
                    </Button>
                  ) : (
                    <Button size="sm" variant="outline" disabled className="flex-1">
                      <Lock className="h-3.5 w-3.5" /> Yakında
                    </Button>
                  )
                )}
              </div>
              {!ready && !m.owned && (
                <div className="mt-2 text-[10px] text-muted-foreground text-center">Modül altyapısı hazır, arayüz yakında</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
